__turbopack_context__.v({
  "button": "my-support-module__yUyK6a__button",
  "myLink": "my-support-module__yUyK6a__myLink",
  "myLinkButton": "my-support-module__yUyK6a__myLinkButton",
  "myLinkGroup": "my-support-module__yUyK6a__myLinkGroup",
  "myLinkGroups": "my-support-module__yUyK6a__myLinkGroups",
  "myLinkList": "my-support-module__yUyK6a__myLinkList",
  "myLinkTitle": "my-support-module__yUyK6a__myLinkTitle",
  "notificationAction": "my-support-module__yUyK6a__notificationAction",
  "notificationCopy": "my-support-module__yUyK6a__notificationCopy",
  "notificationEmpty": "my-support-module__yUyK6a__notificationEmpty",
  "notificationError": "my-support-module__yUyK6a__notificationError",
  "notificationHeading": "my-support-module__yUyK6a__notificationHeading",
  "notificationItem": "my-support-module__yUyK6a__notificationItem",
  "notificationLayout": "my-support-module__yUyK6a__notificationLayout",
  "notificationList": "my-support-module__yUyK6a__notificationList",
  "notificationUnreadIndicator": "my-support-module__yUyK6a__notificationUnreadIndicator",
  "preferenceDescription": "my-support-module__yUyK6a__preferenceDescription",
  "preferenceOption": "my-support-module__yUyK6a__preferenceOption",
  "preferencesForm": "my-support-module__yUyK6a__preferencesForm",
  "preferencesList": "my-support-module__yUyK6a__preferencesList",
  "primary": "my-support-module__yUyK6a__primary",
  "read": "my-support-module__yUyK6a__read",
  "sectionHeading": "my-support-module__yUyK6a__sectionHeading",
  "successCopy": "my-support-module__yUyK6a__successCopy",
  "supportCase": "my-support-module__yUyK6a__supportCase",
  "supportCaseHeading": "my-support-module__yUyK6a__supportCaseHeading",
  "supportCaseItem": "my-support-module__yUyK6a__supportCaseItem",
  "supportCaseLink": "my-support-module__yUyK6a__supportCaseLink",
  "supportCaseList": "my-support-module__yUyK6a__supportCaseList",
  "supportCaseQuestion": "my-support-module__yUyK6a__supportCaseQuestion",
  "supportCaseStatus": "my-support-module__yUyK6a__supportCaseStatus",
  "supportComposer": "my-support-module__yUyK6a__supportComposer",
  "supportEmpty": "my-support-module__yUyK6a__supportEmpty",
  "supportError": "my-support-module__yUyK6a__supportError",
  "supportFallbackMessage": "my-support-module__yUyK6a__supportFallbackMessage",
  "supportForm": "my-support-module__yUyK6a__supportForm",
  "supportHelp": "my-support-module__yUyK6a__supportHelp",
  "supportHistory": "my-support-module__yUyK6a__supportHistory",
  "supportLayout": "my-support-module__yUyK6a__supportLayout",
  "supportMessage": "my-support-module__yUyK6a__supportMessage",
  "supportMessageCashHub": "my-support-module__yUyK6a__supportMessageCashHub",
  "supportMessageLabel": "my-support-module__yUyK6a__supportMessageLabel",
  "supportMessageMeta": "my-support-module__yUyK6a__supportMessageMeta",
  "supportMessageUser": "my-support-module__yUyK6a__supportMessageUser",
  "supportMessages": "my-support-module__yUyK6a__supportMessages",
  "supportSelect": "my-support-module__yUyK6a__supportSelect",
  "supportWaiting": "my-support-module__yUyK6a__supportWaiting",
});
